// extracted by mini-css-extract-plugin
module.exports = {"hintWrap":"CartHazardWarning_hintWrap__40d92","ghsImage":"CartHazardWarning_ghsImage__d4434"};